import { cx } from './cx.js';

/**
 * On/off switch for a setting that applies immediately (crawling paused,
 * admin granted). role="switch" so it announces its state rather than reading
 * as a checkbox that might need submitting.
 */
export function Toggle({
  checked,
  onChange,
  label,
  disabled = false,
  busy = false,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean | undefined;
  busy?: boolean | undefined;
  className?: string | undefined;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-busy={busy || undefined}
      disabled={disabled}
      className={cx('ui-toggle', checked && 'ui-toggle--on', className)}
      onClick={() => onChange(!checked)}
    >
      <span className="ui-toggle__knob" aria-hidden="true" />
    </button>
  );
}
